/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Studio_Topic_PlaceholderInputs */

const en_directory_ai_tools_studio_topic_placeholder = /** @type {(inputs: Directory_Ai_Tools_Studio_Topic_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Names and one detail, e.g. Sam's 30th birthday`)
};

const zh_directory_ai_tools_studio_topic_placeholder = /** @type {(inputs: Directory_Ai_Tools_Studio_Topic_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名字加一个细节，例如：小林 30 岁生日`)
};

/**
* | output |
* | --- |
* | "Names and one detail, e.g. Sam's 30th birthday" |
*
* @param {Directory_Ai_Tools_Studio_Topic_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_topic_placeholder = /** @type {((inputs?: Directory_Ai_Tools_Studio_Topic_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_Topic_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_topic_placeholder(inputs)
	return zh_directory_ai_tools_studio_topic_placeholder(inputs)
});
export { directory_ai_tools_studio_topic_placeholder as "directory.ai_tools.studio.topic_placeholder" }